import { getComponentListByModule } from '@/shared/utils/module_helpers.js';

/**
 * Composable para manejar operaciones relacionadas con módulos
 * @param {number} codigoModulo - Código del módulo (Modules.SOLICITUD, Modules.COTIZACION, etc.)
 * @returns {object} Objeto con funciones y propiedades del módulo
 */
export function useModulo(codigoModulo) {
  // Lista de componentes para el módulo específico (calculada una sola vez)
  const listaComponentes = (() => {
    if (!codigoModulo) return [];

    try {
      return getComponentListByModule(codigoModulo);
    } catch (error) {
      console.warn(`Error al obtener componentes para el módulo ${codigoModulo}:`, error.message);
      return [];
    }
  })();

  /**
   * Obtiene el componente dinámico basado en el código del elemento base
   * @param {number} codigoElementoBase - Código del elemento base
   * @returns {string} Nombre del componente o cadena vacía si no se encuentra
   */
  const getComponenteDinamico = (codigoElementoBase) => {
    if (!codigoElementoBase || !listaComponentes.length) return '';
    const component = listaComponentes.find((item) => item.id === codigoElementoBase);
    const componentName = component && component.componentNameEdit;
    if (!componentName) {
      console.warn(
        `No se encontró componente para código ${codigoElementoBase} en el módulo ${codigoModulo}`,
      );
      return '';
    }
    return componentName || '';
  };

  return {
    listaComponentes,
    getComponenteDinamico,
  };
}
